// Gerado automaticamente por scripts/load-env.js - não edite manualmente
export const environment = {
  "production": false,
  "baseUrl": "https://api-hom.liessin.ewinfo.com.br/v1",
  "environmentName": "staging"
} as const;

export type Environment = typeof environment;